const pushNotificationsOptions = {
  menuData: [
    {
      roleId: '27',
      items: [
        { title: 'National Push Notifications', to: '/push-notifications/national-push-notifications' },
        { title: 'LOB Push Notifications', to: '/push-notifications/lob-push-notifications' },
        { title: 'Branch Push Notifications', to: '/push-notifications/branch-push-notifications' },
        { title: 'Send Centerline Survey', to: '/push-notifications/centerline-survey' },
      ],
    },
    {
      roleId: '28',
      items: [
        { title: 'LOB Push Notifications', to: '/push-notifications/lob-push-notifications' },
        { title: 'Branch Push Notifications', to: '/push-notifications/branch-push-notifications' },
        { title: 'Send Centerline Survey', to: '/push-notifications/centerline-survey' },
      ],
    },
    {
      roleId: '29',
      items: [
        { title: 'Branch Push Notifications', to: '/push-notifications/branch-push-notifications' },
        { title: 'Send Centerline Survey', to: '/push-notifications/centerline-survey' },
      ],
    },
  ],
  statuses: [
    {
      label: 'Pending',
      value: 'Pending',
    },
    {
      label: 'Sent',
      value: 'Sent',
    },
  ],
};

export default pushNotificationsOptions;
